<h2 mat-dialog-title>
  <div class="dialog-title">
    <mat-icon>smart_toy</mat-icon>
    <span>Conversation — {{ data.userDisplayName }}</span>
  </div>
</h2>
<mat-dialog-content class="conversation-dialog-content">
  <app-spinner [isLoading]="loading" diameter="40" loadingText="Loading conversation..."></app-spinner>

  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }

  @if (!loading && !error) {
    <div class="conversation-messages">
      @for (msg of messages; track msg.timestamp) {
        <app-chat-message [message]="msg"></app-chat-message>
      }
      @if (messages.length === 0) {
        <div class="empty-conversation">
          <mat-icon>chat_bubble_outline</mat-icon>
          <p>No messages in this conversation.</p>
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
